module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightrain-e4b308dd2fd4e230da58aa5979be4351.png";